import React, { Component } from 'react'
import DefaultLayout from '../../DefaultLayout'
import Input from '../../../Shared/Form/Input'

import './styles.scss'

import { Col, Container, Row } from '../../../Shared/Grid'
import Box from '../../../Shared/Box'
import Alert from '../../../Shared/Alert'
import { withTranslation } from 'react-i18next'
import Button from '../../../Shared/Form/Button'
import isEmpty from 'lodash.isempty'
import { postRequestCancellation } from '../../../../api'
import Loader from '../../../Shared/Loader'
import BoxedCheckbox from '../../../Shared/Form/BoxedCheckbox'

class CancellationPage extends Component {

  state = {
    email: '',
    formErrors: [],
    showConfirmation: false,
    loading: false,
    error: null,
    checkedAware: false,
    checkedEnsure: false,
  }

  onEmailChange = (event) => {
    this.setState({ email: event.target.value })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    if (!this.isSubmitAllowed()) {
      return
    }
    if (!this.isFormOk()) {
      return
    }

    this.setState({ showConfirmation: false, loading: true, error: null }, () => {
      postRequestCancellation(this.state.email).fetchPromise.then(() => {
        this.setState({ loading: false, showConfirmation: true })
      }).catch(() => {
        this.setState({ loading: false, error: 'Request failed' })
      })
    })
  }

  isFormOk () {
    const { t } = this.props
    const errors = {}
    const requiredFields = [
      'email'
    ]
    for (const requiredField of requiredFields) {
      if (
        this.state[requiredField] === '' ||
        this.state[requiredField] === null ||
        typeof this.state[requiredField] === 'undefined'
      ) {
        errors[requiredField] = t('FORM_FIELD_IS_REQUIRED')
      }
    }
    if (this.state.email !== '' && this.isEmailValid(this.state.email) === false) {
      errors['email'] = t('FORM_FIELD_IS_INVALID')
    }
    this.setState({ formErrors: errors })
    return isEmpty(errors)
  }

  isEmailValid (email) {
    return /^[^@]+?@(?:[^@.]+\.)+[^@.]{2,}?$/.test(email)
  }

  isSubmitAllowed () {
    return this.state.email !== '' && this.state.checkedEnsure && this.state.checkedAware
  }

  render () {
    const { t } = this.props

    return (
      <DefaultLayout>
        <div className="cancellationPage">
          <Box>
            <Container className="cancellationPageContainer" fluid gutterWidth={5}>
              {this.state.loading && <Loader size={32}/>}
              <Row>
                <Col xs={12}>
                  <h3>{t('CANCELLATION')}</h3>
                </Col>
              </Row>
              {this.state.showConfirmation === false ?
                <React.Fragment>
                  <Row>
                    <Col xs={12}>
                      <Alert type={'info'}>
                        {t('CANCELLATION_DESCRIPTION')}
                      </Alert>
                      {this.state.error && <Alert type={'danger'}>{this.state.error}</Alert>}
                    </Col>
                  </Row>
                  <form onSubmit={(e) => this.handleSubmit(e)}>
                    <Row>
                      <Col xs={12} md={6}>
                        <Input value={this.state.email} label={t('EMAIL')} type={'email'}
                               valid={!this.state.formErrors.hasOwnProperty('email')}
                               message={this.state.formErrors.email ? this.state.formErrors.email : ''}
                               onChange={this.onEmailChange} required={true}/>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <BoxedCheckbox onChange={(e) => this.setState({ checkedAware: e.target.checked })}
                                       invert={true} value={this.state.checkedAware} label={t('CANCELLATION_AWARE_TEXT')}/>
                      </Col>
                      <Col xs={12}>
                        <BoxedCheckbox onChange={(e) => this.setState({ checkedEnsure: e.target.checked })}
                                       value={this.state.checkedEnsure} invert={true} label={t('CANCELLATION_ENSURE_TEXT')}/>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Button
                          type={'submit'}
                          disabled={!this.isSubmitAllowed()}
                          align="right"
                          onClick={this.handleSubmit}>{t('SUBMIT')}</Button>
                      </Col>
                    </Row>
                  </form>
                </React.Fragment>
                :
                <Row>
                  <Col xs={12}>
                    <Alert type={'success'}>{t('CANCELLATION_FEEDBACK_REQUEST', { email: this.state.email })}</Alert>
                  </Col>
                </Row>
              }
            </Container>
          </Box>
          }
        </div>
      </DefaultLayout>
    )
  }
}

export default withTranslation()(CancellationPage)
